import React, {useCallback} from 'react';

import {useLocalI18n} from '../../../../../../data/hooks/i18nHooks';
import ActiveFilterButton from '../ActiveFilterButton/ActiveFilterButton';
import strings from '../../BubblesFilter/BubblesFilter.i18n.csv';

const Favorites = props => {
    const {event, filterParams} = props,
        i18n = useLocalI18n(strings),
        active = !!filterParams?.favorites;

    const handleClick = useCallback(
        () =>
            app.store.dispatch(
                app.actions.participants.setFilterParams(event.id, {
                    ...(filterParams || {}),
                    favorites: false,
                })
            ),
        [filterParams]
    );

    return (
        <ActiveFilterButton event={event} onClick={handleClick} visible={active}>
            {i18n['favourites']}
        </ActiveFilterButton>
    );
};

export default Favorites;
